import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'

import Home from './views/Home';
import About from './views/About';
import Contact from './views/Contact';
import Facade from './views/Facade';
import Blog from './views/Blog';
import Gallery from './views/Gallery';
import NotFound from './views/NotFound';
import imageViewer from "vue-image-viewer";
import VueCoreVideoPlayer from 'vue-core-video-player'
Vue.use(VueRouter)
Vue.use(imageViewer);
Vue.use(VueCoreVideoPlayer)
import './scss/main.scss';
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.config.productionTip = false

const router = new VueRouter({
  routes: [
    { path: '/home', name: '/home', component: Home },
    { path: '/about', component: About },
    { path: '/contact', component: Contact },
    { path: '/blog', component: Blog },
    { path: '/gallery', component: Gallery },
    { path: '/', component: Facade },
    { path: '*', component: NotFound }
  ],
  mode: 'hash'
})

new Vue({
  router,
  vuetify,
  created () {
    AOS.init()
  },
  render: h => h(App)
}).$mount('#app')
